import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { IconFieldModule } from 'primeng/iconfield';
import {
  Card,
  OdooFidelityService,
} from 'src/app/services/odoo-fidelity.service';
@Component({
  selector: 'app-fidelity',
  imports: [
    CommonModule,
    ToolbarModule,
    ButtonModule,
    DialogModule,
    InputTextModule,
    FormsModule,
    ToastModule,
    TableModule,
    IconFieldModule,
  ],
  templateUrl: './fidelity.component.html',
  styles: ``,
  providers: [MessageService],
})
export class FidelityComponent implements OnInit {
  messageService = inject(MessageService);
  fidelityService = inject(OdooFidelityService);

  cards: Card[] = [];
  visible = false;
  loading = false;

  card: Card = {
    code: '',
    points: '',
  };

  async ngOnInit() {
    this.loading = true;
    const res = await this.fidelityService.getCards();
    this.cards = res.data.cards;
    this.loading = false;
  }
  showDialog() {
    this.visible = true;
  }

  saveCard() {
    this.loading = true;
    console.log('Card saved:', this.card);
    this.visible = false;
    this.fidelityService
      .addCard(this.card)
      .then(() => {
        this.loading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Alta tarjeta de fidelidad',
          detail: `Se ha dado de alta correctamente la tarjeta de fidelidad con código de barras: ${this.card.code} y saldo: ${this.card.points}€`,
          life: 10000,
        });
      })
      .catch((error) => {
        console.error('Error saving card:', error);
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Error al dar de alta la tarjeta de fidelidad',
          detail:
            'Ha ocurrido un error al dar de alta la tarjeta de fidelidad. Por favor, inténtelo de nuevo más tarde.',
        });
      });
    this.card = {
      code: '',
      points: '',
    };
  }
}
